var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4630_335848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1204 7.7343C15.3099 7.9443 15.4148 8.21713 15.4148 8.50002C15.4148 8.7829 15.3099 9.05573 15.1204 9.26573C13.9204 10.5572 11.189 13.0714 8.00038 13.0714C4.81181 13.0714 2.08038 10.5572 0.880382 9.26573C0.690851 9.05573 0.585937 8.7829 0.585938 8.50002C0.585937 8.21713 0.690851 7.9443 0.880382 7.7343C2.08038 6.44287 4.81181 3.92859 8.00038 3.92859C11.189 3.92859 13.9204 6.44287 15.1204 7.7343Z",
    stroke: "black",
    strokeOpacity: 0.52,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00056 10.7858C9.26292 10.7858 10.2863 9.76244 10.2863 8.50007C10.2863 7.2377 9.26292 6.21436 8.00056 6.21436C6.73819 6.21436 5.71484 7.2377 5.71484 8.50007C5.71484 9.76244 6.73819 10.7858 8.00056 10.7858Z",
    stroke: "black",
    strokeOpacity: 0.52,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4630_335848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewGray);
export default __webpack_public_path__ + "static/media/viewGray.641ed82dcd1e5212a0cf91c11e7aceeb.svg";
export { ForwardRef as ReactComponent };